
import window from 'window';

import Q from 'q';

import config from 'config';

import UnsupportedBrowserHelper from './js/helper.js';


const init = () => {
	const helper = new UnsupportedBrowserHelper();

	if (helper.isBrowserUnsupported()) {
		const configReady = config.cms.pageUrls.get()
			.then(pageUrls => {
				return { cms: { pageUrls } };
			});

		Q(configReady).then(config => {
			window.location = config.cms.pageUrls.s1.outdatedBrowser;
		});
	}
	
};

init();